module.exports = __webpack_public_path__ + "static/media/solution-wuren-banner.a98dbf95.jpg";